import * as TYPES from './types';
export default {
    [TYPES.SET_CUSTOMIZED_CITY](state, payload) {
        state.customizedCity = (payload || []).map(
            ({ name, keyName, key, type }) => {
                const label = name || keyName;
                const value = key;
                return {
                    label,
                    value,
                    type
                };
            }
        );
    },
    [TYPES.SET_IS_EXACT_SEARCH](state, payload) {
        state.isExactSearch = payload;
    },
    [TYPES.SET_PROPERTY_CONFIGS](state, payload) {
        state.propertyConfigs = [...payload];
    },
    [TYPES.SET_SEARCH_CHARTS](state, payload) {
        state.searchCharts = Array.isArray(payload)
            ? [...payload]
            : { ...payload };
    },
    [TYPES.SET_SEARCH_DATA](state, payload) {
        //  Middle platform 
        state.searchData = [...payload];
    },
    [TYPES.SET_SHOW_LOCATION](state, payload) {
        //  Middle platform 
        state.showLocation = payload;
    },
    [TYPES.SET_LOCATION_SUGGESTION_URL](state, payload) {
        state.locationSuggestionUrl = payload;
    },
    [TYPES.SET_KEYWORD](state, payload) {
        state.keyword = payload;
    },
    [TYPES.SET_KEYWORD_TYPE](state, payload) {
        state.keywordType = payload;
    },
    [TYPES.SET_LOCATION_PLACEHOLDER](state, payload) {
        state.locationPlaceholder = payload;
    }
};
